import {Link, LinkProps} from '@mui/material'
import React from 'react'
import {Link as RouterLink} from 'react-router-dom'

export function InAppLink({underline = 'hover', ...rest}: LinkProps<RouterLink>) {
  return <Link underline={underline} component={RouterLink} {...rest} />
}
